<template>
  <v-container v-if="supplier.id > 0" class="home-delivery" id="homeDeliveryView">
    <div v-if="is_delivery_service && !is_take_away_service" :class="[{'changeCitySticky':!isVisible}, 'changeCity']" ref="myButton">
      <change-city
        :location="location" :instance="instance" :supplier="supplier"
        @openCurrentAddress="openCurrentAddress"
      />
    </div>
    <service-select-popup v-if="$store.state.order.service === '' && supplier.id > 0" />
    <v-tabs-items v-model="$store.state.shared.navTabPos" touchless>
      <v-tab-item>
        <purchase-actual v-if="profile.id > 0"></purchase-actual>
        <home-tab-main v-if="this.service.length > 0" @go-tab="$store.state.shared.navTabPos = $event" />
      </v-tab-item>
      <v-tab-item>
        <purchase-actual v-if="profile.id > 0"></purchase-actual>
        <home-tab-main v-if="!this.service.length > 0" @go-tab="$store.state.shared.navTabPos = $event" />
      </v-tab-item>
      <v-tab-item>
        <purchase-actual v-if="profile.id > 0"></purchase-actual>
        <home-tab-main v-if="this.service.length > 0" @go-tab="$store.state.shared.navTabPos = $event" />
      </v-tab-item>
      <v-tab-item v-if="this.subservice !== 'schedule'">
        <home-tab-search />
      </v-tab-item>
      <v-tab-item>
        <home-tab-contact />
      </v-tab-item>
    </v-tabs-items>
    <v-bottom-navigation grow fixed app v-model="$store.state.shared.navTabPos">
      <v-btn active-class="home-bottom-top-border home-buttom-home">
        <span class="font-weight-light" v-html="$t('main_menu.home_tab_title')" />
        <v-icon small>fa-light fa-house</v-icon>
      </v-btn>
      <v-btn @click="goMenu()" class="home-bottom-menu">
        <span class="font-weight-light" v-html="getLabels('menu_tab_title')" />
        <v-icon small>fa-light fa-utensils</v-icon>
      </v-btn>
      <v-btn @click="goOrder()" class="home-buttom-cart">
        <span class="font-weight-light" v-html="$t('main_menu.order_tab_title')" />
        <v-icon small v-if="countProductsList === 0">fa-light fa-cart-shopping</v-icon>
        <v-badge v-if="countProductsList > 0" overlap color="primary" transition="slide-x-transition" :content="countProductsList">
          <v-icon small>fa-light fa-cart-shopping</v-icon>
        </v-badge>
      </v-btn>
      <v-btn v-if="this.subservice !== 'schedule'" active-class="home-bottom-top-border" class="home-buttom-search">
        <span class="font-weight-light" v-html="$t('main_menu.order_tab_search')" />
        <v-icon small>fa-light fa-magnifying-glass</v-icon>
      </v-btn>
      <v-btn active-class="home-bottom-top-border" class="home-bottom-contact-us">
        <span class="font-weight-light" v-html="$t('main_menu.order_tab_contact')" />
        <v-icon small>fa-light fa-bell</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <delivery-current-cart-bottom v-if="(purchaseId !== null || taPurchaseId !== null)" />
    <transition enter-active-class="fadeInDown" leave-active-class="fadeOutUp">
      <current-address v-if="flatCurrentAddress" :location="location" :supplier="supplier" @closeCurrentAddress="closeCurrentAddress" />
    </transition>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { track } from "@/services/track-custom";
import  { delivery } from "@/services/domain";

export default {
  name: "Home",
  beforeRouteLeave(to, from, next) {
    if (this.product_id && this.product_id.length > 0) {
      this.SetProductId(null);
      if (to.name === 'MyOrder' || to.name === 'DeliveryCartInProgress') next();
      else next(false);
    } else {
      next();
    };
  },
  components: {
    DeliveryCurrentCartBottom: () => import(/* webpackChunkName: "deliveryCurrentCartBottom" */ '@/components/delivery/CurrentCartBottom'),
    ServiceSelectPopup: () => import(/* webpackChunkName: "ServiceSelectPopup" */ '@/components/ServiceSelectPopup'),
    PurchaseActual: () => import(/* webpackChunkName: "PurchaseActual" */ '@/components/common/PurchaseActual'),
    HomeTabMain: () => import(/* webpackChunkName: "HomeTabMain" */ '@/components/share/HomeTabMain'),
    HomeTabSearch: () => import(/* webpackChunkName: "HomeTabSearch" */ '@/components/share/HomeTabSearch'),
    HomeTabContact: () => import(/* webpackChunkName: "HomeTabContact" */ '../../components/share/HomeTabContact'),
    ChangeCity: () => import(/* webpackChunkName: "changeCity" */ '@/components/delivery/SetLocation/ChangeCity.vue'),
    CurrentAddress: () => import(/* webpackChunkName: "CurrentAddress" */ '@/components/delivery/SetLocation/CurrentAddress.vue')
  },
  data() {
    return {
      labelMenu: '',
      isVisible: true,
      flatCurrentAddress: false,
      availableProduct: null,
      supplierMessages: [],
      alertChangeProducts: false,
      flatChangeCart: false
    }
  },
  computed: {
    ...mapState('template', ["template"]),
    ...mapState('profile', ["profile","location"]),
    ...mapState('order', ["service", "subservice","purchaseId","taPurchaseId","countProductsList","shoppingCart"]),
    ...mapState('shared', [ "mainCategoryId", "product_id" ]),
    ...mapState('customer', ["supplier","instance","polygon", "isPreview"]),
    ...mapGetters('customer', [ "getLabels" ]),
    ...mapGetters('order', [ "is_delivery_service","is_take_away_service" ]),
    ...mapState('delivery', [ "zone","cutleryStore","packedStore" ]),
  },
  watch: {
    supplier (val) {
      if (this.$route.params.supplier_id !== val.slug) this.$router.push({ params: { supplier_id: val.slug } });
      if (val.id === null) this.GoSelectSupplier();
      if (!val.service_delivery && !val.service_take_away && !this.isPreview) this.$store.state.order.service = "";
      if (val.init_to_menu && !this.template.init_to_menu) {
        this.SetInitToMenu(true);
        this.goMenu();
      };
    },
    service (val) {
      if (val === 'delivery' || val === 'take_away') this.changeService();
      if (val === 'on_table') this.goToHomeOnTable();
    },
    subservice (val) {
      if (val  !== 'room') this.changeService();
    }
  },
  created() {
    this.SetLoading(true);
    this.GetSupplier(this.$route.params.supplier_id);
    this.SetAppClass("");
    this.$store.state.shared.navTabPos = 0;
    this.TemplateActiveHeader({ header_type: "main" });
    this.initHomeDelivery();
  },
  methods: {
    ...mapActions('customer', ["GetSupplier"]),
    ...mapMutations('template', [ "SetLoading", "TemplateActiveHeader", "SetInitToMenu","SetAppClass","SetReload"]),
    ...mapMutations('order', [ "SetCountProductsList","setShoppingCart","SetPurchaseId","SetTaPurchaseId"]),
    ...mapMutations('shared', ["setMainCategory","setCoupon", "SetProductId"]),
    ...mapMutations('delivery', ['setCommentStore']),
    ...mapMutations('profile', ['setLocation']),
    GoSelectSupplier() {
      this.$router.push({ name: "Main" });
    },
    goOrder() {
      track.trackEventCluvi({}, "click to order footertabs");
      if (this.countProductsList > 0) {
        this.$router.push({
          name: "DeliveryCartInProgress",
          params: { supplier_id: this.supplier.slug }
        });
      }
    },
    goMenu() {
      track.trackEventCluvi({}, "click to menu footertabs");
      let hasMainCategories = this.instance.has_main_categories;
      if (!hasMainCategories || this.mainCategoryId > 0) this.goToSubCategories();
      else this.goToMainCategories();
      this.SetLoading(true);
    },
    handleScroll() {
      const button = this.$refs.myButton;
      if (button) {
        const rect = button.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        const isVisible =
          rect.top < windowHeight &&
          rect.left < windowWidth &&
          rect.bottom > 0 &&
          rect.right > 0;
        if (this.isVisible && !isVisible) window.removeEventListener('scroll', this.handleScroll)
        this.isVisible = isVisible;
      };
    },
    topScroll(){
      if (window.scrollY === 0){
        this.isVisible = true;
        window.addEventListener('scroll', this.handleScroll);
      };
    },
    initHomeDelivery() {
      this.$store.state.shared.navTabPos = 0;
      this.$store.state.shared.flatHomeMainCategories = null;
      if (this.service === "on_table") this.goToHomeOnTable();
    },
    goToHomeOnTable () {
      this.$router.push({
        name: "OnTableHome",
        params: { supplier_id: this.supplier.slug }
      });
    },
    goToMainCategories () {
      this.$router.push({
        name: "MainCategories",
        params: { supplier_id: this.supplier.slug }
      });
    },
    goToSubCategories () {
      this.$router.push({
        name: "SubCategories",
        params: { supplier_id: this.supplier.slug }
      });
    },
    emptyOrder () {
      if (!this.taPurchaseId && !this.purchaseId) {
        this.setShoppingCart({ total: 0 });
        this.SetCountProductsList(0);
        this.setCommentStore("");
      };
    },
    openCurrentAddress () {
      this.flatCurrentAddress = true;
    },
    closeCurrentAddress () {
      this.flatCurrentAddress = false;
    },
    getProdcutsBranches () {
      delivery.getProductSupplierByProduct()
        .then(response => {
          if (response.data.length) {
            this.availableProduct = response.data.find(element => element.supplier_id === this.supplier.id);
            this.SetProductId({
              id: this.availableProduct.id,
              product_id: this.availableProduct.product_id
            });
          };
        })
        .catch(error => {
          console.error(error);
        });
    },
    changeService () {
      if (this.purchaseId) this.SetPurchaseId(null);
      if (this.taPurchaseId) this.SetTaPurchaseId(null);
      this.SetReload(false);
      setTimeout(() => this.SetReload(true),500);
    }
  },
  mounted () {
    setTimeout(() => this.SetLoading(false), process.env.VUE_APP_DELAY);
    this.setMainCategory(0);
    this.$store.state.shared.productsFilter = "all";
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.topScroll);
    track.trackView(this,`Home Delivery`,`/${this.$route.params.supplier_id}`);
    track.trackEventCluvi({}, "view home");
    this.emptyOrder();
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.handleScroll);
  },
  metaInfo() {
    return {
      title: this.supplier.label
    };
  }
};
</script>

<style lang="scss" scoped>
  .home-delivery {
    .home-bottom-contact-us {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
  .home-delivery{
    position: relative;
  }
</style>
